var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditPrivate.jinja');
require('./MemberProfileEditPrivate.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileEditPrivate-buttons-button--cancel': 'cancelEdit',
        'click .MemberProfileEditPrivate-buttons-button--save': 'saveEdit'
    },


    saveApi: function () {
        return Urls['member:api:member'](this.options.memberId, 'json');
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'saveApi');

        Base.prototype.initialize.call(this, options);
    },


    saveEdit: function () {
        var $button = this.$('.MemberProfileEditPrivate-buttons-button--save');

        $button.addClass('Button--loading');

        this.saveXhr = $.ajax({
            url: this.saveApi(),
            method: 'PATCH',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                public: this.options.visibility == 'public'
            }),
            success: function (responseData) {

                app.vent.trigger('need-reload', 'my-adg');// refresh my-adg page if it's current underlying page, to update member info block on it

                $button.removeClass('Button--loading');

                //save response to cache, it's important for all popup edit panels, which renders on the fly to show actual data
                //response always contain all profile data up-to-date
                window.app.data.members[this.options.memberId] = responseData;

                window.app.vent.trigger('MemberProfile--updateSettings', this.options.memberId);

                this.cancelEdit();
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    alert('Can\'t update settings!');
                }

                console.log('error', arguments);
            },
            context: this
        });
    },

    cancelEdit: function () {
        this.saveXhr && this.saveXhr.abort();

        window.app.vent.trigger('MemberProfileEdit--close', 'settings');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditPrivate.js
// module id = 214
// module chunks = 0